export const APPLICATION_NAME = process.env.VUE_APP_APPLICATION_NAME;

// APP Settings
export const PROTOCOL = process.env.VUE_APP_PROTOCOL;
export const PORT = process.env.VUE_APP_PORT;
export const DOMAIN = process.env.VUE_APP_DOMAIN;
export const API = process.env.VUE_APP_API;

// Session
/** Token timeout */
export const SESSION_TIMEOUT = (process.env.VUE_APP_SESSION_TIMEOUT && parseInt(process.env.VUE_APP_SESSION_TIMEOUT, 10)) || 3600000; // 1 hour 3600000
/** Token refresh frequency */
export const REFRESH_TOKEN_FREQUENCY = (process.env.VUE_APP_REFRESH_SESSION_FREQUENCY && parseInt(process.env.VUE_APP_REFRESH_SESSION_FREQUENCY, 10)) || 60000; // 1 minutes 60000
/** Time while refresh token is not needed */
export const REFRESH_SESSION_THRESHOLD = (process.env.VUE_APP_REFRESH_SESSION_THRESHOLD && parseInt(process.env.VUE_APP_REFRESH_SESSION_THRESHOLD, 10)) || 600000; // 10 minute 600000

/** Period list size to bring from backend */
export const PERIOD_LIST_SIZE = 8;

/** Default font family * */
export const DEFAULT_FONT_FAMILY = 'Roboto';
